export enum BOOK_INVITE_SUMMARY_ACCENT {
    orange = 'orange',
    purple = 'purple',
    red = 'red',
    green = 'green',
}
